<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="copyright-information">
<br/><br/><br/><br/><br/><br/><br/>
<p><em>“It is an absolute human certainty that no one can know his own beauty or perceive a sense of his own worth until it has been reflected back to him in the mirror of another loving, caring human being.”</em></p><br/>
<p style="text-indent:1em;">― John Joseph Powell</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?394de263